import { JobType } from '@/enum'
import type { IVendor } from '@/interfaces'
import type { IMillOrderJobForm } from '@/interfaces/jobs/mill-orders/IMillOrderJobForm'
import { Vendor } from '@/models/vendors'
import JobForm from '@/models/jobs/JobForm'

class MillOrderJobForm extends JobForm implements IMillOrderJobForm {
  workOrderVendorId: string
  workOrderUrl: string
  workOrderVendor: IVendor

  constructor(jobForm?: any) {
    super(jobForm)
    this.type = JobType.MILL_ORDER
    this.workOrderVendorId = jobForm?.workOrderVendorId
    this.workOrderUrl = jobForm?.workOrderUrl
    this.workOrderVendor = new Vendor(jobForm?.workOrderVendor)
  }
}

export default MillOrderJobForm
